module.exports = __webpack_public_path__ + "img/13.be1eb20f.png";